import CSS from "./static/css/AddressInfo.module.css";
import { Address } from "react-daum-postcode";
import LabelAndContent from "../../../../Component/Elements/LabelAndContent/LabelAndContent";
import Input from "../../../../Component/Elements/Input/Input";
import Postcode from "../../../../Component/Elements/Postcode/Postcode";
import { addHyphens, dev_console } from "../../../../Common/ts/commonTools";
import { Dispatch, ReactNode, SetStateAction, useEffect, useMemo, useState } from "react";
import { ProductDetail_SelectInformationDate_Address_Interface } from "../../static/interface/ProductDetail.interface";
import { addressListManagerClass } from "../../static/ts/common.tools";

const addressListManager = new addressListManagerClass();

const AddressInfo = (
    {
        headerNode,
        setRowAddressData,
        readOnly,
        address_index,
        addressList,
        setAddressList,
    }:{
        headerNode?: ReactNode;
        setRowAddressData?: React.Dispatch<React.SetStateAction<Address | null>>;
        readOnly?: boolean;
        address_index: number;
        addressList: ProductDetail_SelectInformationDate_Address_Interface[];
        setAddressList: Dispatch<SetStateAction<ProductDetail_SelectInformationDate_Address_Interface[]>>;
    }
) => {
    const l_address = useMemo(() => {
        return addressList[address_index];
    }, [addressList, address_index])

    const [isComposing, setIsComposing] = useState(false);
    const [tempName, setTempName] = useState(l_address.recipient_name);
    const [tempPhone, setTempPhone] = useState(l_address.recipient_phone);
    const [addressDetail, setAddressDetail] = useState<string>(l_address.addr_detail);

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTempName(event.target.value);
        if (!isComposing) {
            const data = {
                ...addressList[address_index],
                recipient_name: event.target.value,
            }

            addressListManager.editAddress({
                index: address_index,
                address_list: addressList,
                addressListSetter: setAddressList,
                data,
            })
        }
    };

    const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTempPhone(event.target.value);

        if (!isComposing) {
            const data = {
                ...addressList[address_index],
                recipient_phone: event.target.value.replaceAll("-", ""),
            }

            addressListManager.editAddress({
                index: address_index,
                address_list: addressList,
                addressListSetter: setAddressList,
                data,
            })
        }
    };

    const addressDetailChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAddressDetail(event.target.value);
        if (!isComposing) {
            const data = {
                ...addressList[address_index],
                addr_detail: event.target.value,
            }

            addressListManager.editAddress({
                index: address_index,
                address_list: addressList,
                addressListSetter: setAddressList,
                data,
            })
        }
    }

    const handleCompositionEnd = (type: 'recipient_name' | 'recipient_phone' | 'addr_detail') => {
        setIsComposing(false);

        let m_value: string = "";

        switch(type){
            case 'recipient_name':
                m_value = tempName;
                break;
            case 'recipient_phone':
                m_value = tempPhone;
                break;
            case 'addr_detail':
                m_value = addressDetail;
                break;
        }

        const data = {
            ...addressList[address_index],
            [type]: m_value,
        }

        addressListManager.editAddress({
            index: address_index,
            address_list: addressList,
            addressListSetter: setAddressList,
            data,
        })
    };

    useEffect(() => {
        setTempName(l_address.recipient_name);
    }, [l_address.recipient_name]);

    useEffect(() => {
        setTempPhone(l_address.recipient_phone);
    }, [l_address.recipient_phone]);

    useEffect(() => {
        setAddressDetail(l_address.addr_detail);
    }, [l_address.addr_detail]);

    // useEffect(() => {
    //     dev_console.log("------------------------------------ l_address ------------------------------------");
    //     dev_console.log(tempPhone);
    //     dev_console.log("------------------------------------ l_address ------------------------------------");
    // }, [tempPhone]);

    return(
        <LabelAndContent
            label={
                addressList.length > 1
                ? `배송 정보 ${address_index + 1}`
                : "배송 정보"
            }
            headerNode={headerNode}
            flex_direction={"column"}
            is_view_essential_icon={true}
            class_name_list={[CSS.l_StyleAdd_LabelAndContent]}
        >
            <div className={CSS.l_AddressInfo_main}>
                <div className={CSS.l_recipientInfo_container}>
                    <Input
                        value={tempName}
                        onChange={handleNameChange}
                        onCompositionStart={() => setIsComposing(true)}
                        onCompositionEnd={() => handleCompositionEnd('recipient_name')}
                        placeholder={"받는이"}
                        readOnly={readOnly}
                    />
                </div>

                <div className={CSS.l_recipientPhonenum}>
                    <Input
                        value={addHyphens(tempPhone)}
                        // value={tempPhone}
                        onChange={handlePhoneChange}
                        onCompositionStart={() => setIsComposing(true)}
                        onCompositionEnd={() => handleCompositionEnd('recipient_phone')}
                        placeholder={"연락처"}
                        readOnly={readOnly}
                        maxLength={13}
                    />
                </div>

                <div className={CSS.l_recipientAddress}>
                    <Postcode
                        zonecode={l_address.zip_code}
                        mainAddress={l_address.addr}
                        addressDetail={addressDetail}
                        addressDetailChangeHandler={addressDetailChangeHandler}
                        onCompositionStart={() => setIsComposing(true)}
                        onCompositionEnd={() => handleCompositionEnd('addr_detail')}
                        setRowAddressData={setRowAddressData}
                        readOnly={readOnly}
                    />
                </div>
            </div>
        </LabelAndContent>
    )
}

export default AddressInfo;